/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../dashboard/UndoRedoController',
	'./api/UndoRedoAPI',
	'./api/UndoRedoInternalAPI'
], (APIFactory, UndoRedoController, UndoRedoAPI, UndoRedoInternalAPI) => {
	class UndoRedo {
		constructor({ features }) {
			this.features = features;

			this.undoRedoController = new UndoRedoController(this.features['internal'].getBoardModel(), {
				logger: this.features['Logger'],
				transaction: this.features['Transaction']
			});

			// By default register the Canvas to handle undo/redo for CanvasAPI events
			this.undoRedoController.registerAPIEvents(this.features['Canvas']);
		}

		getAPI(type) {
			if (type === 'internal') {
				if (!this._internal) {
					this._internal = APIFactory.createAPI(this.undoRedoController, [UndoRedoAPI, UndoRedoInternalAPI]);
				}
				return this._internal;
			}
			if (!this._api) {
				this._api = APIFactory.createAPI(this.undoRedoController, [UndoRedoAPI]);
			}
			return this._api;
		}

		destroy() {
			this.undoRedoController.destroy();
		}
	}

	return UndoRedo;
});
